import { UserGender } from "@api-commons/api/types/UserDataTypes.js";
import { AuthProviderIdentifier } from "@api-commons/login/AuthProviderIdentifier.js";
import { LoginMode } from "@api-commons/login/LoginMode.js";
import { CpNativeAppUpstreamBridge } from "@api-commons/nativeapps/CpNativeAppIntegration.js";
import { getRangeByAge } from "./AgeRange.js";
import { CTAStatsDetails, SOURCE_ELEMENT } from "./CTATypes.js";
import { MembershipAnalyticsInfo, StatsCollector } from "./StatsCollector.js";
import { BookmarkAction, DeviceAction, StatDeviceType, TopicAction } from "./UserActionTypes.js";

export class NativeAppUserPropertiesPropagator implements StatsCollector {


    constructor(
        private bridge: CpNativeAppUpstreamBridge
    ) { 

    }


    markUserPersInfo(age: number, userGender: UserGender, memberInfo?: MembershipAnalyticsInfo): Promise<void> {
        const props: { [k: string]: string } = {};
        if (memberInfo) {
            props.membership_type = memberInfo.membership_type;
            props.membership_status = memberInfo.membership_status ? (memberInfo.membership_is_trial?"trial":"active") : "not_active";
        }
        if(age > 0 ) {
            const ar = getRangeByAge(age);
            if(ar && ar.getLiteral() != "") {
                props.age_range = ar.getLiteral();
            }
        }
        if(userGender != UserGender.UNKNOWN) {
            props.user_gender = userGender == UserGender.MALE?"U":"D";
        }
        if(props.age_range || props.user_gender || props.membership_type) this.bridge.setAnalyticsUserProperties(props);
        return Promise.resolve();
    }

    markLoginStatus(loggedIn: boolean, provider: AuthProviderIdentifier | "UNK"): Promise<void> {
        if(loggedIn && provider) {
            this.bridge.setAnalyticsUserProperties({login_status: provider.toUpperCase() + "_LOGIN"});
        }
        return Promise.resolve();
    }

    loginDone(provider: AuthProviderIdentifier | "UNK", mode: LoginMode, newUser: boolean): Promise<void> {
        return Promise.resolve();
    }
    logoutDone(provider: AuthProviderIdentifier | "UNK"): Promise<void> {
        this.bridge.setAnalyticsUserProperties({login_status: null});
        return Promise.resolve();
    }
    collectCTAData(details: CTAStatsDetails): Promise<void> {
        return Promise.resolve();
    }
    collectTopicActionData(source_element: SOURCE_ELEMENT, name: TopicAction, url: string): Promise<void> {
        return Promise.resolve();
    }
    collectDeviceActionData(name: DeviceAction, device: StatDeviceType): Promise<void> {
        return Promise.resolve();
    }
    collectBookmarkActionData(source_element: SOURCE_ELEMENT, name: BookmarkAction, url: string): Promise<void> {
        return Promise.resolve();
    }
    collectPageview(page: string): Promise<void> {
        return Promise.resolve();
    }
    collectBuyMembershipButtonClick(loginRequired: boolean): Promise<void> {
        return Promise.resolve();
    }
    collectLoginDialogButtonPress(sourceSection: AuthProviderIdentifier): Promise<void> {
        return Promise.resolve();
    }
    iosNotificationOpen(): Promise<void> {
        return Promise.resolve();
    }


}